import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text, { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'
import SafeD4signSelect from '../../../../../../containers/integrations/SafeD4signSelect'
import FolderD4signSelect from '../../../../../../containers/integrations/FolderD4signSelect'
import PublicTokenSelect from '../../../../../../containers/publicToken/select/PublicTokenSelect'
import Button from '../../../../../../packages/kiti/components/actions/Button'
import BulkForm from '../../../../../../packages/kiti/components/form/form/BulkForm'
import Scroll from '../../../../../../packages/kiti/components/helpers/Scroll'
import { COLORS } from '@btime/constants'
import { Badge, InputNumber } from 'antd'
import D4SignActSelect from '../../../../../../containers/integrations/D4SignActSelect'
import { prototype } from 'react-markdown'
import FlexGrid from '../../../../../../components/structure/FlexGrid'
import Circle from '../../../../../../packages/kiti/components/shapes/Circle'
import FormSelect from '../../../../../../containers/forms/select/FormSelect'
import { appendIf } from '@btime/helpers'
import Switch, { SwitchWithLabel } from '../../../../../../components/form/Switch'

const useEntity = () => {
  const { form } = useFormState()

  const ENTITY_MAP = {
    event: 'service_order'
  }

  return ENTITY_MAP[form.entity] ?? form.entity
}

const BulkSignersButton = ({ onClick }) => {
  const { t } = useTranslation('triggers')
  const { form } = useFormState()
  return (
    <Button transparent onClick={onClick} badge={form.payload.signers?.length}>
      <Grid>
        <Col marginRight={0.5} width="60%" align="right">
          <Text size={'small'} align="right" color={'primary'} bold>
            {t('d4sign.configureSigners')}
          </Text>
        </Col>
        <Col marginLeft={0.5} width="40%" align="left">
          {!!form.payload.signers?.length && (
            <Circle size={'20px'}>
              <Text color={'white'} size={'xsmall'}>
                {form.payload.signers?.length}
              </Text>
            </Circle>
          )}
        </Col>
      </Grid>
    </Button>
  )
}

const ModalSigners = ({ open, setOpen }) => {
  const { t } = useTranslation('triggers')
  const { form } = useFormState()
  return (
    <Modal zIndex="10000" open={open} onClose={() => setOpen(false)} disableClickOutside width="48rem">
      <Title size="h4" strong color={COLORS.dark2} noMargin>
        {t('d4sign.signers')}
      </Title>
      <Separator weight={5} />
      <Col width="100%">
        <FormItem label={t('d4sign.sequentialSignature')} path={['payload', 'workflow']} Input={SwitchWithLabel} />
      </Col>
      <Separator weight={5} />
      <Scroll height="40rem" scroll scrollX direction="row">
        <BulkForm
          path={['payload', `signers`]}
          fields={[
            { label: t('d4sign.emailRequired'), name: 'email', Input: Textarea, width: `24rem` },
            { label: t('d4sign.actionRequired'), name: 'act', Input: D4SignActSelect }
          ]}
          initialItemState={{}}
          disableMultiEdit
        />
      </Scroll>
      <SubmitBar onClick={() => setOpen(false)} />
    </Modal>
  )
}

const D4signSendToSignersSentence = () => {
  const { handleChange, form } = useFormState()

  const [open, setOpen] = React.useState()
  const [openSigners, setOpenSigners] = React.useState()

  const { t } = useTranslation('triggers')
  const entity = useEntity()

  return (
    <>
      <Text size="h2">para os </Text>
      <Separator weight={2} />

      <EditableSentence label={t('d4sign.signers')} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <ModalSigners open={openSigners} setOpen={setOpenSigners} />

      <Modal open={open} onClose={() => setOpen(false)} disableClickOutside width="48rem">
        <Title size="h3" strong color={COLORS.dark2} noMargin>
          {t('d4sign.configureDocumentSending')}
        </Title>
        <Separator weight={5} />

        <Col width="100%">
          <FormItem label={t('d4sign.documentName')} path={['payload', 'file_name']} />
        </Col>

        <Separator weight={5.5} />
        <Col width="100%">
          <Text color={COLORS.red}>{form.payload.signers__error}</Text>
          <BulkSignersButton
            transparent
            onClick={() => {
              if (form.payload.signers == null || !Array.isArray(form.payload.signers)) {
                handleChange('payload', { ...form.payload, signers: [] })
              }
              return setOpenSigners(true)
            }}
            badge={form.payload.signers?.length}
            size="small"
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label={t('d4sign.safe')}
            path={['payload', 'safe']}
            Input={SafeD4signSelect}
            filter={{ integrationId: form.integrationId }}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label={t('d4sign.folderOptional')}
            path={['payload', 'folder']}
            Input={FolderD4signSelect}
            filter={{ integrationId: form.integrationId, safeId: form.payload?.safe?.id }}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem label={t('d4sign.document')} path={['payload', 'document']} Input={Textarea} />
        </Col>

        <Separator weight={4} />
        <Col width="100%">
          <FormItem
            label={t('d4sign.publicTokenForWebhook')}
            path={['payload', 'public_token']}
            entity={entity}
            Input={PublicTokenSelect}
          />
        </Col>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default D4signSendToSignersSentence
